<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <b-table small striped hover bordered :fields="fields" :items="visitItems" :per-page="perPage" :current-page="currentPage" responsive="sm">
                        <template #cell(index)="data">
                            {{ data.index + startPage }}
                        </template>
                        <template #cell(icon)="data">
                            <img class="profile-image-md rounded-circle" :src="data.item.icon != '' ? getImage(data.item.icon) : require('@/assets/image/icon/profile.png')"/>
                        </template>
                        <template #cell(temperature)="data">
                            {{data.item.temperature}} °C
                        </template>
                        <template #cell(createDate)="data">
                            {{convertTimestampToDateTime(data.item.createDate)}}
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired, setReturnData, getOutletName} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "visitList",
    data(){
        return{
            isSpinnerShow: false,
            filterObj: {},
            outlet: [],
            visitItems: [],
            exportData: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "mobile", label: "Phone Number", thClass: 'thead-themed align-middle', sortable: true},
                {key: "temperature",label: "Temperature", thClass: 'thead-themed align-middle'},
                {key: "createDate", label:"Visit Date", thClass: 'thead-themed align-middle', sortable: true},
            ]
        }, 
        exportField(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.username')).toUpperCase()] = "username"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.working_hour')).toUpperCase()] = "duration"
            ret[(this.$i18n.t('table.header.clock_in')).toUpperCase()] = "entryDate"
            ret[(this.$i18n.t('table.header.clock_out')).toUpperCase()] = "exitDate"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.exportData)
        }
    },
    methods:{
        convertTimestampToDateTime(date){
            return moment(date*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        getImage(img){
            return img;
        },
        getDuration(strDuration){
            var result = ""
            var arrDuration = strDuration.split(":")
            var hr = arrDuration[0]
            var min = arrDuration[1]

            if(hr.indexOf('-') != -1){
                result = "Present"
            }else{
                hr = parseInt(hr)
                if(hr > 24){
                    var d = Math.floor(hr/24);
                    var rm = hr % 24;
                    hr = Math.floor(rm);

                    result =  d + " Days " + hr + " Hr " + min + " Mins"    
                }else{
                    result = hr + " Hr " + min + " Mins"
                }
            }
            return result
        },
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        async setVisitItems(filterObj){
            this.filterObj = filterObj;           
            var dateFilter = ""
            if(filterObj.dateType != 'all'){
                dateFilter = filterObj.dateType == "entry" ? 
                "&startEntryDate=" + moment(filterObj.date.startDate).unix() + "&endEntryDate=" + moment(filterObj.date.endDate).unix() :
                "&startExitDate=" + moment(filterObj.date.startDate).unix() + "&endExitDate=" + moment(filterObj.date.endDate).unix() 
            }
            else{
                dateFilter = "&startCreateDate=" + 1000000000 + "&endCreateDate=" + moment().endOf('month').unix() 
            }

            var memberFilter = filterObj.memberID.id == "all" || filterObj.memberID.id == undefined ? "" : "&memberID=" + filterObj.memberID.id
            var typeFilter = filterObj.type == "all" ? "" : "&status=" + filterObj.type
            var outletFilter = "&outletID="+filterObj.outletID
            var strFilter = dateFilter + outletFilter + memberFilter + typeFilter;
            
            this.isSpinnerShow = true
            var res = await this.getVisitItems()
            res.visits.forEach(element => {
                res.members.forEach(item => {
                    if(element.memberID === item.memberID)
                    Object.assign(element,item)
                });
            });
            var retData = [];
            //Check for filter Props
            if(filterObj.memberID.text.includes("All Member")){
                retData = res.visits;
            }
            else{
                retData = res.visits.filter(item=>{
                console.log(item)
                if(item.memberID.toString().includes(filterObj.memberID.id)){
                    return item;
                }
            });
            }
            var result = setReturnData(retData, this.totalEntries, this.page)
            this.visitItems = result.result;
            this.totalPage = result.totalPage;

            this.startPage = result.startPage;
            this.endPage = result.endPage;
            this.isSpinnerShow = false;

            if(filterObj.memberID.id == "all" ){
                this.$emit('setMemberFilter', res.members, filterObj.memberID)
            }
            await this.getExportData()
        },
        async getVisitItems(){
            let $vm = this;
            let QUERY_STRING = this.$api.REPORT_VISIT
            const url = QUERY_STRING;
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
                $vm.totalEntries = response.data.visits.length;              
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getExportData(){
            let $vm = this;
            let QUERY_STRING = this.$api.REPORT_VISIT
            const url = QUERY_STRING;
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
                $vm.totalEntries = response.data.visits.length;              
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.exportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            if(this.filterObj.dateType == "all"){
                strDate = " ("+ this.$i18n.t('salon_report.visit.all_date_types') + ")"
            }else{
                var dateType = this.$i18n.messages[this.$i18n.locale].salon_report.visit.option_date_filter
                var strDateType = dateType.filter(obj=> obj.value == this.filterObj.dateType)[0].text

                strDate = " (" + strDateType + ": "
                + moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT) + ")";
            }

            let header = this.$msg.REPORT.HEADER  + this.$i18n.t('subMenu.salon_report_visit') + strDate
            var exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            var exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    name: data[i].name,
                    username: data[i].username,
                    outlet: this.getOutletName(data[i].outletID),
                    duration: this.getDuration(data[i].duration),
                    entryDate: this.convertTimestampToDateTime(data[i].entryDate),
                    exitDate: data[i].exitDate == 0 ? "-" : this.convertTimestampToDateTime(data[i].exitDate),
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.exportField,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        },
        async handlePagination(pg){
                  if (pg != null) {
         this.page = pg;
        this.startPage =((pg-1)*100)+1;
        this.endPage = pg * 100;
        if(this.endPage>this.totalEntries){
          this.endPage = this.totalEntries;
        }
      }
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
